export const APEX_CREDIT_PURCHASE_MODAL = 'APEX_CREDIT_PURCHASE_MODAL'

export const CLIENT_GROUP = 2
export const CLIENT_CONFIRM_MODAL = 'CollateralFormClientConfirmModal'
export const CLIENT_EDIT = 'ClientEditInCollateralForm'

export const LK_GRID_NAME = 'APEX_COLLATERALS_GRID'

export const COLLATERALS_FETCHER_NAME = 'APEX_COLLATERALS_GRID'

export const formName = 'frm_collateral_view'
export const objectName = 'dbgrd_hypo'

export const mediumMonthDays = 30.4375
export const daysInOneWeek = 7

export const COVER_PENALTY_ID = 110 //05 cover penalty

export const TBI_USD_ACCOUNT_ID = 1861012

export const OP_CODE_DISBURSE_ID = 4
export const OP_CODE_COVER_ID = 3

export const RADIO_DISBURSE_VALUE = '1'
export const RADIO_COVER_VALUE = '2'

export const OPCODE_ID_CANCEL_SELL = 111
export const OPCODE_ID_PENALTY = 110
export const OPCODE_ID_REFUND = 109
export const DIRECTOR_ID = 6

export const COLLATERAL_STATE_TO_BE_SOLD = 10

export const DEFAULT_OPCODE_VALUE = 0
export const millisecondsToDays = 86400000
export enum ApexCreditTabs {
  CREATE_CREDIT_PURCHASE,
  COLLATERAL_SEARCH,
  OPERATIONS,
}

type TabsWithPermissions = {
  [key in keyof typeof ApexCreditTabs]: string[]
}

export const commonPermissions = ['VIEW_COLLATERAL', 'EDIT_CLIENT', 'ADD_COLLATERAL']
export const tabsPermissions: TabsWithPermissions = {
  CREATE_CREDIT_PURCHASE: [
    'VIEW_APPLICATION',
    'ADD_APPLICATION',
    'ADD_LOAN',
    'LOAN_ATTACH_COLL',
    'ADD_COMITTEE_DECISION',
  ],
  COLLATERAL_SEARCH: ['VIEW_LOAN'],
  OPERATIONS: ['LOAN_DISBURSE', 'LOAN_COVER_OPER', 'LOAN_COVER_CORRECT', 'EDIT_COLLATERAL', 'ACC_ENTRIES_ADD_MEMORDER'],
}

export const contextMenuPermissions = {
  VISA: ['COLLATERAL_VISA', 'LOAN_VISA', 'LOAN_VISA_FORCURR'],
}
